
import * as React from 'react';
import { Box, Stack } from '@mui/material';
import { blue, yellow } from '@mui/material/colors';
import { getSecondsToTextWithSec, repeatEffect, settingsConfig, toFormatedDateMMDDHHmm } from 'utils/commonFunc';
import ApiService from 'services/ApiService';
import { ResponsivePie } from '@nivo/pie';
import { ResponsiveBar } from '@nivo/bar';
import { defaultChartProps } from 'pages/components/CustomDashboardChart';
import StackedBarChartIcon from '@mui/icons-material/StackedBarChart';
import ColorInfoBox from 'pages/components/ColorInfoBox';
import BaseTitleBox from 'pages/components/BaseTitleBox';
import PieChartIcon from '@mui/icons-material/PieChart';

const colors = ['var(--pr-50-80)', 'var(--alert-50-80)']

export default function EmergencyVehicleChart1View(props) {
    const [currentData, setCurrentData] = React.useState()

    // React.useEffect(() => {
    //     return repeatEffect(
    //         async () => {
    //             // const response = await ApiService.get("newdashboard/sgnloprt/GetSuwonMonthHistory");
    //             const response = await ApiService.get("dashboard/emergVeh/GetSuwonMonthHistory");
    //             if (response.status === 200) {

    //                 const data = response.data;
    //                 if (props.serviceNum ?? 0 === 1) {
    //                     setCurrentData({
    //                         title: '수원시 긴급차량 도착시간',
    //                         pieChartText: `최근 월별  평균 도착시간`,
    //                         barChartText: `기관별 평균 도착시간`,
    //                         valueFormat: (v => `${getSecondsToTextWithSec(v)}`),
    //                         pieChartData: data.monthRows.map(p => ({ id: p.month === '1M' ? "최근 1개월" : "이전 1개월", value: p.avgTravelTime })),
    //                         barChartData: data.locationRows.map(p => (
    //                             {
    //                                 location: p.location,
    //                                 value1: p.rows[0].avgTravelTime,
    //                                 value2: p.rows[1].avgTravelTime,
    //                             }
    //                         ))
    //                     })
    //                 } else {
    //                     setCurrentData({
    //                         title: '수원시 긴급차량 출동건수',
    //                         pieChartText: `최근 월별 총 출동건수`,
    //                         barChartText: `기관별 월별 출동건수`,
    //                         valueFormat: (v => `${v.toLocaleString()} 건`),
    //                         pieChartData: data.monthRows.map(p => ({ id: p.month === '1M' ? "최근 1개월" : "이전 1개월", value: p.totalCount })),
    //                         barChartData: data.locationRows.map(p => (
    //                             {
    //                                 location: p.location,
    //                                 value1: p.rows[0].totalCount,
    //                                 value2: p.rows[1].totalCount,
    //                             }
    //                         ))
    //                     })
    //                 }
    //             }
    //         },
    //         settingsConfig().contentUpdateDelaySec)
    // // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, []);

    React.useEffect(() => {
        return repeatEffect(
            async () => {
                // const response = await ApiService.get("dashboard/emergVeh/GetSuwonMonthHistory");
                const response = await ApiService.get("newdashboard/sgnloprt/GetSuwonMonthHistory");
                if (response.status === 200) {
                    const data = response.data;

                    // "경기도 교통정보센터(테스트)" 제외
                    const filteredLocationRows = data.locationRows.filter(
                        loc => loc.location !== "경기도 교통정보센터(테스트)"
                    );

                    if ((props.serviceNum ?? 0) === 1) {
                        setCurrentData({
                            title: '수원시 긴급차량 도착시간',
                            pieChartText: `최근 월별 평균 도착시간`,
                            barChartText: `기관별 평균 도착시간`,
                            valueFormat: (v) => `${getSecondsToTextWithSec(v)}`,
                            pieChartData: data.monthRows.map(p => ({
                                id: p.month === '1M' ? "최근 1개월" : "이전 1개월",
                                value: p.avgTravelTime
                            })),
                            barChartData: filteredLocationRows.map(p => ({
                                location: p.location,
                                value1: p.rows[0].avgTravelTime,
                                value2: p.rows[1].avgTravelTime
                            }))
                        });
                    } else {
                        setCurrentData({
                            title: '수원시 긴급차량 출동건수',
                            pieChartText: `최근 월별 총 출동건수`,
                            barChartText: `기관별 월별 출동건수`,
                            valueFormat: (v) => `${v.toLocaleString()} 건`,
                            pieChartData: data.monthRows.map(p => ({
                                id: p.month === '1M' ? "최근 1개월" : "이전 1개월",
                                value: p.totalCount
                            })),
                            barChartData: filteredLocationRows.map(p => ({
                                location: p.location,
                                value1: p.rows[0].totalCount,
                                value2: p.rows[1].totalCount
                            }))
                        });
                    }
                }
            },
            settingsConfig().contentUpdateDelaySec
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div style={{ display: 'flex', flexDirection: 'row', height: '100%', padding: 20, gap: 40 }}>
            {currentData &&
                <Box sx={{ width: '100%', height: '100%', position: 'relative' }}>
                    <Stack sx={{ width: '100%', height: '100%' }}
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                        spacing={4}>
                        <Stack sx={{ width: '100%', height: '100%' }}
                            direction="column"
                            justifyContent="center"
                            alignItems="center"
                            spacing={1}>
                            <BaseTitleBox sx={{
                                width: '90%',
                                borderRadius: '12px',
                                bgcolor: 'rgba(255, 255, 255, 0.05)',
                                padding: '12px 20px',
                                border: '1px solid rgba(255,255,255,0.2)',
                                boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                                color: '#fff',
                            }} align="center" icon={<PieChartIcon />} title={currentData.pieChartText} />
                            <Box sx={{ width: '100%', height: '90%' }}>
                                <ResponsivePie
                                    {...defaultChartProps}
                                    theme={{
                                        text: {
                                            fontSize: '28px',
                                            fill: `#FFFFFF`,
                                        }
                                    }
                                    }
                                    data={currentData?.pieChartData}
                                    margin={{ top: 80, right: 80, bottom: 80, left: 80 }}
                                    activeOuterRadiusOffset={8}
                                    borderWidth={0.5}
                                    borderColor="rgba(255, 255, 255, 0.5)"
                                    value={'value'}
                                    id="id"
                                    colors={colors}
                                    arcLabel={e => currentData?.valueFormat(e.value)}
                                    //arcLinkLabel={e => `${dayjs(e.id).format('YY년 MM월')}`}                                    
                                    arcLinkLabelsSkipAngle={10}
                                    arcLinkLabelsThickness={2}
                                    arcLinkLabelsColor="rgba(255, 255, 255, 0.5)"
                                    arcLinkLabelsTextColor="#fff"
                                    arcLabelsSkipAngle={10}
                                    arcLabelsTextColor="#fff"
                                    isInteractive={false}
                                    legends={[]}
                                />
                            </Box>
                        </Stack>
                        <Stack sx={{ width: '100%', height: '100%' }}
                            direction="column"
                            justifyContent="center"
                            alignItems="center"
                            spacing={1}>
                            <BaseTitleBox
                                align="center"
                                sx={{
                                    width: '90%',
                                    borderRadius: '12px',
                                    bgcolor: 'rgba(255, 255, 255, 0.05)',
                                    padding: '12px 20px',
                                    border: '1px solid rgba(255,255,255,0.2)',
                                    boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                                    color: '#fff',
                                }} icon={<StackedBarChartIcon />} title={currentData.barChartText} />
                            <Box sx={{ width: '100%', height: '90%' }}>
                                <ResponsiveBar
                                    {...defaultChartProps}
                                    theme={{
                                        text: {
                                            fontSize: '26px',
                                            fill: `#FFFFFF`,
                                        }

                                    }}
                                    layers={[
                                        'grid',
                                        'axes',
                                        ({ bars }) =>
                                            <>
                                                {bars.map((bar, index) => (
                                                    <React.Fragment key={index}>
                                                        <rect
                                                            x={bar.x}
                                                            y={bar.y}
                                                            width={bar.width}
                                                            height={bar.height}
                                                            rx={6}
                                                            ry={6}
                                                            fill={bar.color}
                                                        />
                                                        {bar.data.value > 0 && (
                                                            <text
                                                                x={bar.x + bar.width + 10} 
                                                                y={bar.y + bar.height / 2}
                                                                textAnchor="start" 
                                                                alignmentBaseline="central"
                                                                fill="#ffffff"
                                                                style={{ fontSize: '24px', fontWeight: '500' }}
                                                            >
                                                                {bar.data.formattedValue}
                                                            </text>
                                                        )}
                                                    </React.Fragment>
                                                ))}
                                                {/* {bars.map((bar, index) => (
                                                    <React.Fragment key={index}>
                                                        <rect
                                                            x={bar.x}
                                                            y={bar.y}
                                                            width={bar.width}
                                                            height={bar.height}
                                                            rx={6}
                                                            ry={6}
                                                            fill={bar.color}
                                                        />
                                                        {bar.data.value > 0 && bar.height > 20 && (
                                                            <text
                                                                x={bar.x + bar.width / 2}
                                                                y={bar.y + bar.height / 2}
                                                                textAnchor="middle"
                                                                alignmentBaseline="central"
                                                                fill="#ffffff"
                                                                style={{ fontSize: '24px', fontWeight: '500' }}
                                                            >
                                                                {bar.data.formattedValue}
                                                            </text>
                                                        )}
                                                    </React.Fragment>
                                                ))} */}
                                            </>,
                                        'markers',
                                        'legends',
                                        'annotations'
                                    ]}
                                    data={currentData?.barChartData}
                                    keys={['value1', 'value2']}
                                    indexBy="location"
                                    margin={{ top: 20, right: 120, bottom: 50, left: 120 }}
                                    padding={0.1}
                                    innerPadding={2}
                                    groupMode="grouped"
                                    layout="horizontal"
                                    valueFormat={currentData?.valueFormat}
                                    labelTextColor="#fff"
                                    colors={colors}
                                    axisTop={null}
                                    axisRight={null}
                                    axisBottom={null}
                                    axisLeft={{
                                        tickSize: 0,
                                        tickPadding: 20,
                                        tickRotation: 0,
                                    }}
                                    enableGridY={false}
                                />
                            </Box>
                        </Stack>
                    </Stack>
                    <Stack sx={{ width: '100%', position: 'absolute', bottom: '0', right: '0' }}
                        direction="row"
                        justifyContent="flex-end"
                        alignItems="center"
                        spacing={4}>
                        <ColorInfoBox color={colors[0]} text={`${currentData?.pieChartData[0].id}`} />
                        <ColorInfoBox color={colors[1]} text={`${currentData?.pieChartData[1].id}`} />
                    </Stack>
                </Box>
            }
        </div>
    )
}
